import React from 'react';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import { withLocalize } from "react-localize-redux";
import history from '../../history';

import { Link } from 'react-router-dom';

import { InputText } from '../input/InputText.tsx';
import { SelectLabeled } from '../input/SelectLabeled.tsx';
import ContainerTranslation from "../partials/ContainerTranslation";

import { createUser } from '../../actions/user';


class UserCreate extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      fields : 4,
      form : {
        email : {value : ""},
        lastName : {value : ""},
          firstName: { value: "" },
          group: {value: "ikos"}
        
      },
      message : null
    }
  }


  UNSAFE_componentWillReceiveProps(nextProps) {
    if(nextProps.message && nextProps.message === "User successfully created!"){
      history.push('/user');
    }
  }

  handleInputTextChange(obj, bool){
    
    var form = Object.assign({},this.state.form);
    
    form[obj.target.name] = {value : obj.target.value, isValid : bool};
    this.setState({form : form})

    if(this.state.message !== ""){
      this.setState({message : ""})
    }

  }

    handleInputGroupChange(obj) {

        let form = Object.assign({}, this.state.form);

        form['group'] = { value: obj.value, isValid: true };
        this.setState({ form: form })

    }

  handleEmailChange(obj, bool){
    
    const regexEmail = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i;

    var form = Object.assign({},this.state.form);
    
    form[obj.target.name] = {value : obj.target.value, isValid : regexEmail.test(obj.target.value)};
    this.setState({form : form})

    if(this.state.message !== ""){
      this.setState({message : ""})
    }

  }


  handleCreateUser(){

    var form = Object.assign({},this.state.form);
    var fields = 0;
    var bool = true

    for (let property in form) {
      fields++
    }

    if(fields === this.state.fields && bool === true){
      var obj = {}
      for (var property in form) {
        obj[property] = form[property].value
      }

      this.props.createUser(obj);

    }else{
      this.setState({message : "Le formulaire n'est pas correctement rempli"})
    }

  }

  render() {
    return (
      <div className="register">
        <div className="col-2">
                <h1><ContainerTranslation id={'Page.User.CreateUser.title'} /></h1>
          <div className="form-container">
            {this.state.message !== '' ?
              <p className="warning">{this.state.message}</p> : null
            }
            {this.props.error !== '' ?
              <p className="warning">{this.props.error}</p> : null
            }
            <form className="form-auth">
              <div>
                <InputText 
                  onChange={this.handleEmailChange.bind(this)}
                  value={this.state.form.email.value}
                  name={'email'}
                  isRequired={true}
                                placeholder={this.props.translate('Page.User.CreateUser.Placeholder.email')} 
                  label={{title : this.props.translate("user.Email.title")}}
                />
              </div>
              <div>
                <InputText
                  onChange={this.handleInputTextChange.bind(this)}
                  value={this.state.form.lastName.value}
                  name={'lastName'}
                  isRequired={true}
                                placeholder={this.props.translate('Page.User.CreateUser.Placeholder.name')} 
                  label={{title : this.props.translate("user.Name.title")}}
                />
              </div>
            <div>
              <InputText
                onChange={this.handleInputTextChange.bind(this)}
                value={this.state.form.firstName.value}
                name={'firstName'}
                isRequired={true}
                placeholder={this.props.translate('Page.User.CreateUser.Placeholder.firstName')} 
                label={{title : this.props.translate("user.First Name.title")}}
                            />
                        </div>
                        <div>
                            <SelectLabeled
                                label={{ title: "group" }}
                                value={{ value: this.state.form.group.value, label: this.state.form.group.value }}
                                onChange={this.handleInputGroupChange.bind(this)}
                                options={[{ value: 'ikos', label: 'ikos' },
                                    { value: 'airtren', label: 'airtren' },
                                    { value: 'aegis', label: 'aegis' },
                                    { value: 'alcapem', label: 'alcapem' },
                                    { value: 'bps', label: 'bps' },
                                ]}
                            />
                        </div>
            </form>
          </div>
          <div className="button-bar">
            <button className="view-btn" onClick={this.handleCreateUser.bind(this)}><ContainerTranslation id={'Page.User.CreateUser.btn-Validate'} /></button>
            <Link to="/user"><button className="secondary-btn"><ContainerTranslation id={'Page.User.CreateUser.btn-back'} /></button></Link>
          </div>
        </div>
      </div>
    )
  }
}

const mapStateToProps = state => ({
  message: state.user.message,
  error: state.user.error
})

const mapDispatchToProps = dispatch => bindActionCreators({
  createUser,
}, dispatch);

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(withLocalize(UserCreate)));
